import React from 'react'
import { compose } from 'redux'

// moderation
import {
  MODERATION_STATUS_REQUIRED
} from 'lib/moderation/status'

// mutations
import withModerationStatusMutation from 'mutations/withModerationStatusMutation'

// result handling
import withActionResult from './withActionResult'

// presentational component
import AdminUnapproveConfirm from 'components/FileActionConfirm/AdminUnapproveConfirm'

const withAdminUnapproveAction = (WrappedComponent) => {
  const AdminUnapproveAction = (props) => {
    const {
      file,
      activeAction, // from withActiveFileAction
      onClickCancel, // from withActionResult
      onSubmitSuccess, // from withActionResult
      onSubmitFailure, // from withActionResult
      submitModerationStatus
    } = props

    const handleClickUnapprove = () => {
      const input = {
        moderation_status: MODERATION_STATUS_REQUIRED
      }

      submitModerationStatus(file.id, input)
        .then(onSubmitSuccess)
        .catch(error => onSubmitFailure(error, 'Error updating moderation status'))
    }

    return (
      <WrappedComponent
        {...props}
        visible={activeAction === 'unapprove'}
        onClickUnapprove={handleClickUnapprove}
        onClickCancel={onClickCancel}
      />
    )
  }

  return AdminUnapproveAction
}

export default compose(
  withModerationStatusMutation,
  withActionResult,
  withAdminUnapproveAction
)(AdminUnapproveConfirm)
